import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faCircleExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';

import Portal from '@mui/material/Portal';

import { SnackbarRoot } from './styles';
import { snackbarClasses } from './classes';

// ----------------------------------------------------------------------

export function Snackbar() {
  return (
    <Portal>
      <SnackbarRoot
        gap={12}
        offset={16}
        visibleToasts={4}
        position="top-right"
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: snackbarClasses.toast,
            icon: snackbarClasses.icon,
            loader: snackbarClasses.loader,
            loading: snackbarClasses.loading,
            /********/
            content: snackbarClasses.content,
            title: snackbarClasses.title,
            description: snackbarClasses.description,
            /********/
            closeButton: snackbarClasses.closeButton,
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            /********/
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning,
          },
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: <FontAwesomeIcon className={snackbarClasses.iconSvg} icon={faInfo} />,
          success: <FontAwesomeIcon className={snackbarClasses.iconSvg} icon={faCheck} />,
          warning: (
            <FontAwesomeIcon className={snackbarClasses.iconSvg} icon={faTriangleExclamation} />
          ),
          error: <FontAwesomeIcon className={snackbarClasses.iconSvg} icon={faCircleExclamation} />,
        }}
      />
    </Portal>
  );
}
